
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { X } from 'lucide-react';

const COMMON_FEATURES = [
  "مكيف هواء", "موقف سيارة", "مصعد", "حديقة", "شرفة", "مطبخ مجهز", 
  "غرفة خادمة", "مخزن", "أمن وحراسة", "مسبح", "نادي رياضي", "انترنت",
  "غسالة", "ثلاجة", "تدفئة مركزية", "إطلالة بحرية", "قريب من المدارس",
  "قريب من المستشفيات", "مواصلات عامة", "منطقة هادئة"
];

interface FeaturesStepProps {
  data: any;
  onChange: (field: string, value: any) => void;
}

const FeaturesStep = ({ data, onChange }: FeaturesStepProps) => {
  const [customFeature, setCustomFeature] = useState("");
  const selectedFeatures = data.features || [];

  const addFeature = (feature: string) => {
    if (!selectedFeatures.includes(feature)) {
      onChange('features', [...selectedFeatures, feature]);
    }
  };

  const removeFeature = (feature: string) => {
    onChange('features', selectedFeatures.filter((f: string) => f !== feature));
  };

  const addCustomFeature = () => {
    if (customFeature.trim() && !selectedFeatures.includes(customFeature.trim())) {
      onChange('features', [...selectedFeatures, customFeature.trim()]);
      setCustomFeature("");
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-right flex items-center gap-2">
          <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">3</div>
          مميزات العقار
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* المميزات الشائعة */}
        <div>
          <h3 className="text-md font-medium mb-3 text-right">المميزات الشائعة</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
            {COMMON_FEATURES.map(feature => (
              <Button
                key={feature}
                type="button"
                variant={selectedFeatures.includes(feature) ? "default" : "outline"}
                size="sm"
                onClick={() => selectedFeatures.includes(feature) ? removeFeature(feature) : addFeature(feature)}
                className="text-right justify-start h-auto py-2 px-3"
              >
                {feature}
              </Button>
            ))}
          </div>
        </div>

        {/* إضافة ميزة مخصصة */}
        <div>
          <h3 className="text-md font-medium mb-3 text-right">إضافة ميزة مخصصة</h3>
          <div className="flex gap-2">
            <Input
              value={customFeature}
              onChange={(e) => setCustomFeature(e.target.value)}
              placeholder="أدخل ميزة جديدة"
              className="text-right"
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  addCustomFeature();
                }
              }}
            />
            <Button type="button" onClick={addCustomFeature}>إضافة</Button>
          </div>
        </div>

        {/* المميزات المحددة */}
        {selectedFeatures.length > 0 && (
          <div>
            <h3 className="text-md font-medium mb-3 text-right">المميزات المحددة</h3>
            <div className="flex flex-wrap gap-2">
              {selectedFeatures.map((feature: string) => (
                <Badge key={feature} variant="secondary" className="flex items-center gap-1">
                  {feature}
                  <X 
                    className="h-3 w-3 cursor-pointer" 
                    onClick={() => removeFeature(feature)}
                  />
                </Badge>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default FeaturesStep;
